module.exports = __webpack_public_path__ + "static/media/illustration-your-users.8a5af995.svg";